/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToDoCountComponent } from './to-do-count.component';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [ToDoCountComponent],
  exports: [ToDoCountComponent],
  entryComponents: [ToDoCountComponent],
  imports: [CommonModule, AngularSvgIconModule]
})
export class ToDoCountModule {}

export { ToDoCountComponent };

export * from './count';
